import TranslatePageStructureIntoReferencedFieldList from './TranslatePageStructureIntoReferencedFieldList';

const PopulateDynamicListsOnLoad = (retrievedData, pageStructure, lists) => {

    let  fields = TranslatePageStructureIntoReferencedFieldList(pageStructure);
    fields = fields.filter(f => f.Type === "dropdown" || f.Type === "combobox" || f.Type === "filteredcombo");

    for (const field of fields) {
        if (field.ParentList !== "") {
            const list = lists.filter(l => l.Name.toLowerCase() === field.OptionsName.toLowerCase());
            let parentField = fields.filter(f => f.Id === field.ParentList);
            if (parentField.length > 0) {
                field.Options = list[0].Options.filter(f => f.ParentKey === parentField[0].value).map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}});
            } else {
                // If parent field is not part of the current form, check for its value in retrieved data.
                let retrievedKeys = Object.keys(retrievedData);
                parentField = retrievedKeys.filter(r => r === field.ParentList);
                field.Options = list[0].Options.filter(f => f.ParentKey === retrievedData[parentField[0]]).map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}});
            }
        }
        else if (field.ParentValue !== ""){     
            const list = lists.filter(l => l.Name.toLowerCase() === field.OptionsName.toLowerCase());                
            field.Options = list[0].Options.filter(f => f.ParentKey === field.ParentValue).map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}}); 
            let i = 0;       
        }   
    }
}

export default PopulateDynamicListsOnLoad;
